<div class="w-full h-full flex items-center justify-center ">

    <img  style="max-height: 80vh; width:auto;" [src]="imgsource"  />

</div>